import React, {PropsWithChildren, useMemo} from 'react';
import {NotificationContext} from './context';
import {useGetNotificationsCallback} from './useGetNotifications';

export const NotificationProvider = ({children}: PropsWithChildren) => {
  const {notificationsData, fetchNotifications} = useGetNotificationsCallback();

  const memoValue = useMemo(() => {
    return {notificationsData, fetchNotifications};
  }, [fetchNotifications, notificationsData]);

  return (
    <NotificationContext.Provider value={memoValue}>
      {children}
    </NotificationContext.Provider>
  );
};
